import { useSelector } from 'react-redux';
import { selectors } from 'farmx-redux-core';

export function useUserTimeFormat() {
  const userSettings = useSelector((state) => selectors.selectUserSettings(state));
  const use12hrsFormat = userSettings?.units_time === '12_hour';
  const timeFormat = use12hrsFormat ? 'h:mma' : 'HH:mm';
  return { unitsTime: use12hrsFormat, timeFormat };
}
